import React, { Component } from 'react';
import Toggle from "react-toggle";
import Layout from "../../Components/Layout";
import Dendrogram from "../../Components/DendrogramContainer";
import Footer from '../../Components/Footer';






export default class DisplayTiki extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleDendrogram: true
    }
    this.handleToggleDendrogram = this.handleToggleDendrogram.bind(this);
  }

  handleToggleDendrogram() {
    this.setState((prevState) => { 
      return {
        toggleDendrogram: !prevState.toggleDendrogram
      }
     });
     console.log(this.state.toggleDendrogram);
  }

  render() {
    return (
      <div className="App">
        <Layout
          head={<TitleElement />}
          body={
            <React.Fragment>
              <Toggle
                id="dendrogramToggler"
                defaultChecked={ this.state.toggleDendrogram }
                onChange={ this.handleToggleDendrogram }
                aria-label="Toggle view"
                icons={false}
              />
              { this.state.toggleDendrogram ? <Dendrogram /> : <Dendrogram quarterCircle />}
            </React.Fragment>
          }
          footer={<FooterElement />}
        />
      </div>
    );
  }
}

const TitleElement = () => (
  <div><h1>Dendrogram Display</h1></div>
)
const FooterElement = () => (
  <div><p>Courtesy of GERS - Grow early, rapidly and securely</p></div>
)



// WEBPACK FOOTER //
// ./src/Pages/Misc/DisplayTiki.js